import React from "react";

//Context creation to update state between components. Should implement Redux store for more complex scenarios
const NavContext = React.createContext({ currentProject: '', setCurrentProject: () => { } });

// Refactoring from named export to default was needed for stateful components
export default NavContext;